import isFuture from 'date-fns-old/is_future';
import validateDate from './validateDate';

// Validates that the input string is a valid date formatted as "mm-dd-yyyy"
const validateInputDOB = dateString => {
  // Check for the pattern
  const invalidPattern = !/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateString);
  if (invalidPattern) return false;

  // Check the ranges of year/month/day
  // Parse the date parts to integers
  const parts = dateString.split('-');
  const day = parseInt(parts[1], 10);
  const month = parseInt(parts[0], 10);
  const year = parseInt(parts[2], 10);
  const invalidDate = !validateDate(year, month, day);
  if (invalidDate) return false;

  // Check if entered dob is not in the future
  const date = new Date(year, month - 1, day);
  return !isFuture(date);
};

export default validateInputDOB;



// WEBPACK FOOTER //
// ./src/utils/validateInputDOB.jsx